import React from "react";
import {
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Text,
	Link,
	OrderedList,
	ListItem,
	Divider,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

const linkedInUrl =
	"https://www.linkedin.com/in/kiranmysoreravi/?originalSubdomain=jp";

const FundInFocusOct: React.FC = () => (
	<>
		{/* members */}
		<Flex
			as="section"
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height={{ xs: "450px", sm: "300px" }}
			minH={{ xs: "450px", sm: "300px" }}
			maxH="450px"
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/jpg/blogBanner.jpg"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDir="column"
				px={{ xs: "20px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
			>
				<Heading
					as="h1"
					mb="20px"
					variant="reportCardTitle"
					fontSize={{ xs: "26px", sm: "28px", md: "32px", lg: "38px" }}
					color="white"
					lineHeight={{ xs: "34px", md: "39px", lg: "42px" }}
				>
					Fund in Focus: UTEC&apos;s Hands-On Approach to Deep-Tech Investing in
					India and Beyond
				</Heading>
			</Container>
		</Flex>
		<Container
			as="section"
			maxW="container.xl"
			pb="80px"
			pt="40px"
			minH="420px"
			display={{ xs: "flex", md: "inherit" }}
			flexDirection="column"
		>
			<Box as="main" w="100%" pb="40px">
				<Text variant="blogAnswer">
					Welcome to our ‘Fund in Focus’ series where we profile our member
					funds, underscore their investment philosophy, and highlight some of
					their interesting work. Today we speak to{" "}
					<Link
						href={linkedInUrl}
						target="_blank"
						style={{
							textDecoration: "underline",
						}}
						rel="noreferrer"
					>
						Kiran Mysore
					</Link>
					, Principal, University of Tokyo Edge Capital Partners{" "}
					<Link
						href="https://www.ut-ec.co.jp/english/"
						target="_blank"
						style={{
							textDecoration: "underline",
						}}
						rel="noreferrer"
					>
						(UTEC)
					</Link>
					. In this feature, Kiran delves we delve into UTEC’s remarkable
					journey as one of Asia&apos;s leading deep-tech venture capital firms.
					With a focus on profound science and technology, UTEC is empowering
					startups to pioneer innovations that can transform the world. Discover
					their extraordinary success stories, investment strategy, and insights
					for entrepreneurs seeking UTEC&apos;s support.
				</Text>
			</Box>

			<Img
				src="https://static.levocdn.com/WGLBUT82/7120413705120405875.jpg"
				alt="Kiran Mysore"
				boxSize="300px"
				float={{ xs: "right", md: "left" }}
				alignSelf={{ xs: "center", md: "flex-start" }}
				mx={{ xs: "0px", md: "0px" }}
				mr={{ xs: "0px", md: "40px", lg: "60px", xl: "70px" }}
				mb="20px"
				objectFit="cover"
				rounded="full"
			/>
			<Flex flexDir={{ xs: "column", lg: "row" }} rowGap="16px">
				<Heading
					textAlign={{ xs: "center", md: "left" }}
					fontWeight="800"
					color="blue.400"
				>
					Spokesperson: Kiran Mysore, Principal, University of Tokyo Edge
					Capital Partners (UTEC)
				</Heading>
				<Flex
					columnGap={{ xs: "4px", md: "16px" }}
					justifyContent={{ xs: "center", md: "flex-start" }}
					transform={{ xs: "translateX(12px)", md: "none" }}
				>
					<Box alignSelf="center">
						<Link href={linkedInUrl} target="_blank">
							<IconButton
								aria-label="linkedin"
								icon={
									<FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />
								}
								variant="unstyled"
								cursor="pointer"
							/>
						</Link>
					</Box>
				</Flex>
			</Flex>
			<Box>
				<Box
					ml={{ xs: "auto", md: "345px", lg: "370px" }}
					mr={{ xs: "auto", md: "0px" }}
					width={{ xs: "160px", md: "80px" }}
					h="2px"
					bgColor="primary.500"
					borderRadius="5px"
					mt={{ xs: "16px", md: "10px" }}
					mb="15px"
				/>
				<Box mt="16px" mb="20px">
					<Heading variant="blogQuestion" mb="20px">
						1. Can you provide an overview of University of Tokyo Edge Capital
						Partners (UTEC), including its history, mission, and core investment
						philosophy?
					</Heading>
					<Text variant="blogAnswer">
						We are a Japan-based VC firm doing hands-on lead investments in
						global science and deep-tech startups. Often regarded as one of the
						largest deep-tech VC firms in Asia, we have raised 5 funds with a
						cumulative AUM of 85 Billion Yen. Our most recent fund is UTEC 5, a
						30 Billion Yen fund that we raised in June 2021. Our previous fund
						UTEC 4 was ranked by Preqin JVCA VC fund benchmark as the
						top-performing Japanese VC fund among the ones with a fund size of
						$100M+.
						<br />
						<br />
						We are an independent VC firm that raises LP money from
						institutional investors, but we work closely with universities for
						deal sourcing and value-add. Our closest association is with The
						University of Tokyo, but we have worked with spin-off companies from
						several Japanese and Global universities (refer to the infographic).
						<br />
						<br />
						UTEC was founded in 2004, and since then, we have done over 150
						investments with a track record of 20 IPOs & 20 M&As. Some of our
						success cases: PeptiDream (listed on TSE in 2013), Finatext Holdings
						(listed on TSE in 2021), ACSL (listed on TSE in 2018), 908 Devices
						(listed on NASDAQ in 2020), and Oriciro Genomics (acquired by
						Moderna in 2023)
						<br />
						<br />
						Our mission is to create new industries, to solve global issues of
						humankind, by bringing together capital, talent, and knowledge,
						around science and technology.
						<br />
					</Text>
				</Box>
				{/* Question 2 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pb="20px" pt="12px">
						2. What sets UTEC apart from other venture capital funds in terms of
						your investment strategy and approach?
					</Heading>
					<Text variant="blogAnswer" pt="16px">
						Broadly speaking, UTEC focuses on investments in three areas:
					</Text>
					<OrderedList listStyleType="lower-alpha">
						<ListItem>
							<Text variant="blogAnswer" pl={{ md: "12px", lg: "18px" }}>
								Healthcare and Life sciences
							</Text>
						</ListItem>
						{/* 2nditem */}
						<ListItem>
							<Text variant="blogAnswer" pl={{ md: "12px", lg: "18px" }}>
								AI and IT
							</Text>
						</ListItem>
						{/* 3rditem */}
						<ListItem>
							<Text variant="blogAnswer" pl={{ md: "12px", lg: "18px" }}>
								Physical sciences and Engineering
							</Text>
						</ListItem>
					</OrderedList>
					<Text variant="blogAnswer" py="16px">
						We especially look for fundamental IP-driven companies that address
						some of the most important global issues such as aging population,
						labor shortage, digitization of legacy industries, climate change,
						etc. We are seed/early investors. Our first check size is about
						$500,000 to $5 million with a strong commitment as lead investors,
						and we can invest ~$15M as follow-on capital over the lifecycle of
						the company.
						<br />
						<br />
						We often work with researchers in university labs to incubate the
						company at the pre-company formation stage and help them with: Proof
						of Concepts, Business Plan, Team Building, and then help them set up
						a corporate entity – a ‘Venture Creation’ model. In addition, we
						have built a platform team of experts to offer hands-on support to
						our portfolio in the following: Research Collaborations with Global
						Academia, Japan/Global Market Expansion, Recruitment of Global
						Professionals, Collaborations with Japanese and Global Corporations,
						and Follow-on Fundraising from Japanese and Global Investors.
						Furthermore, we at UTEC often work together with governmental
						agencies to help craft innovation-friendly policies. UTEC’s Managing
						Partner & CEO{" "}
						<b>
							Mr. Tomotaka Goji was elected as the Chairman of JVCA (Japan
							Venture Capital Association){" "}
						</b>
						in July 2023.
					</Text>
				</Box>

				{/* Question 3 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="28px">
						3. UTEC is based in Japan. How does your fund approach global
						investment opportunities, and which sectors are you particularly
						focused on in India? Could you share any future plans?
					</Heading>
					<Text variant="blogAnswer" mt="16px" mb="8px">
						Since 2018, we have increased our investment in overseas deep-tech
						startups that possess strong synergies with Japanese industries and
						academia. While most global VC firms often view emerging countries
						merely as large market opportunities, we firmly believe that these
						countries can be hotbeds for globally competent innovation. In fact,
						we have made 10-15 deep-tech investments in emerging markets such as
						India, Southeast Asia, and Africa.
						<br />
						<br />
						India might be the only emerging economy with deep-tech innovation
						that can rival Silicon Valley. It boasts world-class universities
						and research labs (including corporate labs), but at a much lower
						cost structure and with a culture of frugal innovation. The Indian
						startup ecosystem also shares elements with Israel&apos;s. For
						instance, much like Israeli startups, Indian companies always have
						global aspirations. Moreover, India&apos;s B2B market, though not
						small, is steadily growing, drawing parallels to China. The
						combination of these factors makes it very appealing for a global
						fund like ours.
						<br />
						<br />
						Furthermore, India and Japan are natural long-term partners with
						complementary strengths. The software innovation of India, combined
						with the hardware and infrastructure capabilities of Japan, is a
						perfect match. In India, we are keenly exploring sectors such as
						Manufacturing and Robotics, Automotive & Mobility, Generative AI
						applied to legacy industries, and IP-led healthcare/Biotech
						innovations.
						<br />
					</Text>
				</Box>
				<Img
					src="https://static.levocdn.com/WGLBUT82/7120414062180492612.jpg"
					alt="Infographic Image"
					px="40px"
					mx={{ xs: "0px", md: "0px" }}
					mr={{ xs: "0px", md: "40px", lg: "60px", xl: "70px" }}
					mb="20px"
					objectFit="cover"
				/>
				{/* Question 4 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						4. Could you share some notable success stories or portfolio
						companies in India that UTEC has supported and the impact
						they&apos;ve made?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						We see two types of deep tech innovations in India – addressing both
						local and global markets.
					</Text>
					<OrderedList listStyleType="upper-alpha">
						<ListItem>
							<Text variant="blogAnswer" pl={{ md: "12px", lg: "18px" }}>
								<b>Science-led Innovation:</b>
								<br />
								This is based on fundamental research and often originates from
								academic labs of universities or researchers who have worked in
								R&D departments of large corporates for several years. They push
								the boundaries of science, and can be categorized as new
								discoveries. We are one of the earliest and largest investors in
								Bugworks Research - a great example of this. Bugworks has
								platform technology combining medicinal chemistry, structural
								biology, and computational modelling that has given rise to
								multiple drug assets to tackle the global problem of AMR
								(antimicrobial resistance) and oncology. They recently became
								the first company in the world in Phase 1 stage to partner with
								Global Antibiotic R&D Partnership (GARDP), an initiative by
								World Health Organization.
								<br />
								<br />
								Another example is our portfolio The ePlane Company, which is
								building the most compact eVTOL aircrafts in the world to
								address of the problem of mid-mile mobility and logistics. The
								startup was incubated at IIT Madras and its work is based on
								decades of research in aerospace by Dr. Satya Chakravarthy, a
								professor at IIT Madras.
								<br />
							</Text>
						</ListItem>
						{/* 2nditem */}
						<ListItem>
							<Text variant="blogAnswer" pl={{ md: "12px", lg: "18px" }}>
								<b> Engineering-led Innovations:</b> <br />
								They combine elements of engineering, design, software,
								mathematics, and other fields to make the product work in the
								real world. Our portfolio company Tricog Health falls in this
								bucket. Tricog offers AI-driven analysis of ECGs
								(electrocardiogram) and echocardiograms to diagnose heart
								diseases in India, SEA and Africa, touching 12 million patients.
								They combine decades of experience in cardiology, embedded
								systems, and deep learning. Similarly, UTEC’s portfolio Agara
								that leveraged deep learning to build fully autonomous voice
								agents for customer support was acquired by Coinbase in 2021.
								<br />
							</Text>
						</ListItem>
					</OrderedList>
				</Box>
				{/* Question 5 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						5. How does UTEC envision the role of venture capital in shaping the
						future of technology and innovation in India? Japan has a growing
						start-up ecosystem. Any similarities or differences you have noticed
						between Japanese and Indian start-up ecosystems?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						We firmly believe that synergizing Indian deep-tech startups with
						Japanese industrial and scientific collaborations can pave the way
						for global success stories. For instance, our portfolio company,
						Tricog Health, recently secured strategic financing from Japanese
						conglomerates, Omron Healthcare and Sony, to expand their solutions
						worldwide. Similarly, Bugworks Research enjoys a fruitful
						collaboration with the Tokyo Institute of Technology. Their joint
						R&D endeavors have even led to a research publication in Nature
						Communications.
						<br />
						India&apos;s deep-tech innovations hold the potential to influence
						over 5 billion lives in the emerging world. Some of these
						innovations might also find relevance in developed nations,
						particularly with the emerging trend of Reverse Innovation. The
						global community stands to gain immensely from more problem-first
						deep-tech startups from India. These startups can address the
						pressing global challenges, especially in today&apos;s world marred
						by conflicts and confrontations. While the first wave of Indian
						startups was consumer-centric and the second wave heralded the rise
						of Indian SaaS, we are now witnessing the third wave—The Golden Era
						of Indian Deep-tech. There&apos;s a clear parallel between the
						trajectory of Japan&apos;s deep-tech startup ecosystem from the past
						decade and India&apos;s current deep-tech landscape, where
						pioneering success stories are just beginning to emerge.
						<br />
					</Text>
				</Box>
				{/* Question 6 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						6. How does UTEC identify promising startups to invest in, and what
						criteria do you consider when evaluating potential investments? For
						entrepreneurs and startups seeking investment from UTEC, what advice
						or tips can you offer to stand out and make a compelling pitch?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						Our investment criteria has remained consistent for the last 19
						years: a) Profound Science & Technology, b) Strong and diverse team,
						c) Addressing the global issues of humankind.
						<br />
						<br />
						We&apos;ve initiated collaborations with incubators at several
						universities and research institutions in India, including
						IIT-Madras and C-CAMP Bangalore, and have engaged with their
						spin-off companies. We also develop &apos;theses and themes on
						technology inflection points&apos; and proactively reach out to
						researchers and entrepreneurs. A notable example is our investment
						in the US/India-based startup, Obviously AI, which stemmed from our
						&apos;democratization of AI and future of work&apos; thesis.
						Moreover, we adopt a collaborative stance in our India-related
						activities, working with various early-stage VC firms in the country
						such as Blume Ventures. This synergy blends UTEC&apos;s deep-tech
						expertise with the local market knowledge of Indian VC firms. From
						our experience, the cornerstone of a deep-tech startup&apos;s
						success in India, whether they&apos;re driven by science or
						engineering, lies in adopting a problem-first approach. Combining
						technological prowess with operational excellence is crucial, and
						these are the attributes we seek in a compelling startup pitch.
					</Text>
				</Box>
			</Box>
			<Divider borderWidth="1px" borderColor="black" />
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				The content in this section is curated by Team IVCA. For any feedback,
				connect with&nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default FundInFocusOct;
